import type { Stats } from "@tih/shared";

/** Label beside the public viewer/view count stat. */
export function statsWatchLabel(stats: Stats | null | undefined, fallback = "watching now"): string {
  if (!stats) return fallback;
  if (stats.youtubeLive) return "watching now";
  if (stats.statsSource === "youtube") return "YouTube views";
  return fallback;
}
